module.exports = __webpack_public_path__ + "img/cupcake.2ca37fc4.svg";